//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bgContain from '../components/bgContain';
import bgContain2 from '../components/bgContain2';
import { alarm_list, alarm_about } from '@/api/pests';
import ImageMap from '@/view/components/imageMap/imageMapDes';
import review from './component/review.vue';
import detailsCom from './component/details.vue';
export default {
  data: function data() {
    var _this = this;

    return {
      loading: false,
      handle_type: [],
      height: 200,
      image_height: null,
      image_width: null,
      imageSrc: null,
      x_axis: null,
      y_axis: null,
      axis: [],
      tabletotallen: 0,
      reqBase: {
        page: 1,
        page_size: 15
      },
      columns1: [{
        title: '报警内容',
        key: 'name',
        align: 'center',
        render: function render(h, _ref) {
          var row = _ref.row;
          var result = row.project_name + '项目 ' + row.device_name + '发生【' + row.alarm_type_name + '】报警 ' + row.alarm_time + ' ' + row.address;
          return h('div', {
            style: {
              color: '#fff',
              textAlign: 'left'
            }
          }, result);
        }
      }, {
        align: 'center',
        title: '状态',
        width: 100,
        key: 'status',
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var color = '';
          var text = "";

          if (row.status === 2) {
            color = "success";
            text = "已处理";
          } else if (row.status === 1) {
            color = "error";
            text = "未处理";
          }

          return h('Tag', {
            props: {
              color: color
            }
          }, text);
        }
      }, {
        align: 'center',
        title: '操作',
        width: 80,
        key: 'Operating',
        render: function render(h, _ref3) {
          var row = _ref3.row;
          var arr = [];
          var result = null;
          var ref = row.id;
          var vm = _this;

          if (row.status === 1) {
            return h('Poptip', {
              props: {
                placement: 'right',
                width: 400,
                transfer: true,
                title: '处理'
              },
              on: {}
            }, [h('Button', {
              props: {
                type: 'primary'
              }
            }, '处理'), h('div', {
              slot: 'content'
            }, [h(review, {
              ref: ref,
              props: {
                id: row.id,
                _vm: vm,
                handle_type: vm.handle_type
              },
              on: {
                init: function init() {
                  vm.init();
                }
              }
            })])]);
          } else if (row.status === 2) {
            return h('Poptip', {
              props: {
                placement: 'right',
                width: 400,
                transfer: true,
                title: '查看'
              },
              on: {}
            }, [h('Button', {
              props: {
                type: 'primary'
              }
            }, '查看'), h('div', {
              slot: 'content'
            }, [h(detailsCom, {
              ref: ref,
              props: {
                id: row.id,
                _vm: vm,
                setData: row
              },
              on: {}
            })])]);
          }

          return result;
        }
      }],
      data1: [],
      operationButtonList: [{
        name: '处理',
        type: 'primary',
        icon: '',
        show: [1],
        method: this.edit
      }, {
        name: '查看',
        type: 'primary',
        icon: '',
        show: [2],
        method: this.details
      }]
    };
  },
  components: {
    bgContain: bgContain,
    bgContain2: bgContain2,
    ImageMap: ImageMap
  },
  methods: {
    getAlertType: function getAlertType() {
      var _this2 = this;

      alarm_about().then(function (res) {
        if (res.result === 0) {
          _this2.handle_type = res.body.handle_type || [];
        }
      });
    },
    pageOnchange: function pageOnchange(page) {
      this.$set(this.reqBase, 'page', page);
      this.init();
    },
    init: function init() {
      var _this3 = this;

      this.loading = true;
      alarm_list(this.reqBase).then(function (res) {
        _this3.data1.splice(0);

        _this3.loading = false;

        if (res.result === 0) {
          _this3.data1 = res.body.list || [];
          _this3.tabletotallen = res.body.total;

          if (_this3.data1.length > 0) {
            var item = _this3.data1[0];

            _this3.getAxios(item);
          }
        } else {}
      });
    },

    /**
     * 点击行数时
     */
    onRowClick: function onRowClick(row, index) {
      this.getAxios(row);
    },
    getAxios: function getAxios(item) {
      this.axis.splice(0);
      this.imageSrc = item.file_url + '&t=' + new Date().getTime(), this.y_axis = item.y_axis;
      this.x_axis = item.x_axis;
      this.image_height = item.enlarge_height;
      this.image_width = item.enlarge_width;
      var arr = item.device_list;

      for (var i in arr) {
        var _item = arr[i];
        var check = false;

        if (this.x_axis === _item.x_axis && this.y_axis === _item.y_axis) {
          check = true;
        } else {
          check = false;
        }

        this.axis.push({
          x: _item.x_axis,
          y: _item.y_axis,
          name: _item.device_name,
          check: check
        });
      } // console.log(this.axis)

    },
    edit: function edit() {},
    details: function details() {},
    onResize: function onResize() {
      var tableH = document.getElementById('tableWrapper1');
      this.$set(this, 'height', tableH.offsetHeight - 55);
      this.height = tableH.offsetHeight - 55; // console.log(this.height)
    },
    getQuery: function getQuery() {
      var query = this.$route.query;

      if (query.id) {
        this.$set(this.reqBase, 'id', query.id);
      }

      if (query.status) {
        this.$set(this.reqBase, 'status', query.status);
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.getQuery();
    this.init();
    this.getAlertType();
    this.$nextTick(function () {
      _this4.onResize();

      window.addEventListener('resize', _this4.onResize);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.onResize);
  }
};